import styled from "styled-components";

export const GREEN = "#019A32";

export const MainDiv = styled.div`
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    font-family: "Segoe UI", sans-serif;
    color: #334155;
`;
export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
`;
export const Title = styled.h2`
    margin: 0;
    font-size: 20px;
    color: #166534;
`;
export const Button = styled.button`
    padding: 9px 14px;
    border-radius: 8px;
    border: 1px solid ${({ $secondary }) => $secondary ? "#d1d5db" : GREEN};
    background: ${({ $secondary }) => $secondary ? "white" : GREEN};
    color: ${({ $secondary }) => $secondary ? "#166534" : "white"};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    &:hover { background: ${({ $secondary }) => $secondary ? "#eaf8ef" : "#08783b"}; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const Filters = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 15px;
`;
export const Select = styled.select`
    padding: 9px 12px;
    border: 1px solid #dce8df;
    border-radius: 8px;
    background: white;
    font-size: 13px;
    cursor: pointer;
`;
export const TaskList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
export const TaskRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px;
    background: white;
    border: 1px solid #e2e8e5;
    border-radius: 11px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: border-color 0.2s ease;
    &:hover { border-color: #b7ddc2; }
    @media (max-width: 600px) { gap: 8px; padding: 8px; }
`;
export const TaskPhoto = styled.img`
    width: 85px;
    height: 85px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 8px;
    background: #f1f5f9;
    cursor: pointer;
    @media (max-width: 600px) { width: 65px; height: 65px; }
`;
export const TaskInfo = styled.div`flex: 1; min-width: 0;`;
export const Comment = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #26352d;
    margin-bottom: 5px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
`;
export const Info = styled.div`font-size: 11px; color: #64748b; margin-bottom: 3px;`;
export const StatusButton = styled.button`
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid ${({ $done }) => $done ? "#a7dfb3" : "#f5dfa2"};
    background: ${({ $done }) => $done ? "#dcfce7" : "#fef3c7"};
    color: ${({ $done }) => $done ? "#166534" : "#92400e"};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const PhotoList = styled.div`display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;`;
export const SmallPhoto = styled.img`
    width: 45px; height: 45px; object-fit: cover; border-radius: 6px;
    cursor: pointer; border: 1px solid #dce8df;
`;
export const PhotoContainer = styled.div`position: relative; width: 75px; height: 75px;`;
export const PhotoPreview = styled.img`
    width: 100%; height: 100%; object-fit: cover; border-radius: 8px; cursor: pointer;
`;
export const RemovePhoto = styled.button`
    position: absolute; top: -5px; right: -5px; width: 22px; height: 22px;
    background: #dc2626; color: white; border: none; border-radius: 50%; cursor: pointer;
`;
export const Overlay = styled.div`
    position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65);
    display: flex; align-items: center; justify-content: center; padding: 15px; z-index: 1000;
`;
export const Modal = styled.div`
    width: 100%; max-width: 480px; max-height: 90vh; overflow-y: auto;
    box-sizing: border-box; background: white; border-radius: 14px; padding: 20px;
`;
export const Field = styled.div`
    display: flex; flex-direction: column; gap: 6px; margin: 12px 0;
    label { font-size: 13px; font-weight: 600; }
    input, textarea, select {
        width: 100%; padding: 10px; box-sizing: border-box;
        border: 1px solid #dce8df; border-radius: 8px;
        font-family: "Segoe UI", sans-serif; font-size: 13px;
    }
    textarea { min-height: 90px; resize: vertical; }
`;
export const ModalButtons = styled.div`
    display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 8px; margin-top: 18px;
`;
export const PhotoActions = styled.div`display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px;`;
export const Lightbox = styled.div`
    position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,0.92);
    display: flex; align-items: center; justify-content: center;
    padding: 45px 15px 15px; box-sizing: border-box;
    img { max-width: 100%; max-height: 100%; object-fit: contain; }
`;
export const CloseButton = styled.button`
    position: absolute; top: 15px; right: 20px; background: none; border: none;
    color: white; font-size: 32px; cursor: pointer;
`;
export const Message = styled.div`padding: 20px; text-align: center; color: #64748b;`;
